import request from "./core";

export const getNotificationList = ({ page }: { page: number }) => {
  return request.get<GetNotificationList>("/notification/list", {
    params: {
      page,
      size: 10,
    },
  });
};

export const getNotificationCount = () => {
  return request.get<{ count: number }>("/notification/count");
};

export const patchNotificationReadAll = () => {
  return request.patch("/notification/readAll");
};

export const patchNotificationReadId = (notificationId: number) => {
  return request.patch(`/notification/read/${notificationId}`);
};
